module.exports = __webpack_public_path__ + "img/unknown.8f9f3ac5.svg";